import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";
import { UsersContext } from "../Components/Context/UsersContext";

const LoginRoutes = ({ minRole, component: Component, location, ...rest }) => {
  const { currentUser, isLoadingUser } = useContext(UsersContext);
  const cookies = new Cookies();

  const enroutingPage = (props) => {
    if (cookies.get("jes") && currentUser)
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: location },
          }}
        />
      );

    if (isLoadingUser) return <>Cargando ...</>;

    if (!cookies.get("jes")) return <Component {...props} />;

    return <Component {...props} />;
  };

  return (
    <>
      <Route {...rest} render={(props) => enroutingPage(props)}></Route>
    </>
  );
};

export default LoginRoutes;
